export const DatasetSlugs = {
    TOOLING: 'studies_tooling',
    MARKETING_COMP: 'studies_marketing_team_compensation',
    CREATIVE_STRATEGY: 'studies_creative_strategy',
    AI_INITIATIVES: 'studies_ai_initiatives_v3',
    AGENCY_COMP: 'studies_agency_compensation',
};
